import { types } from './bandeira.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'
import _ from 'lodash'

const initialState = {
  id: 'bandeira',
  booleanFilter: { status: '' },
  showHideColumns: [
    {
      label: 'Seleção',
      value: {
        field: 'multiselect',
        header: 'Seleção',
        columnKey: 'multiselect',
        visible: false,
      },
    },
    {
      label: 'ID',
      value: {
        field: 'oid',
        header: 'ID',
        columnKey: 'oid',
        sortable: true,
        filter: true,
        columnSortField: 'oid',
        visible: true,
      },
    },
    {
      label: 'Cartão',
      value: {
        field: 'cartao',
        header: 'Cartão',
        columnKey: 'cartao',
        sortable: true,
        filter: true,
        columnSortField: 'cartao',
        visible: true,
      },
    },
    {
      label: 'Código',
      value: {
        field: 'codigo',
        header: 'Código',
        columnKey: 'codigo',
        sortable: true,
        filter: true,
        columnSortField: 'codigo',
        visible: true,
      },
    },
    {
      label: 'Forma Pagamento',
      value: {
        field: 'formaPagamento',
        header: 'Forma Pagamento',
        columnKey: 'formaPagamento',
        sortable: true,
        filter: true,
        columnSortField: 'formaPagamento',
        visible: true,
      },
    },
    {
      label: 'Unidade',
      value: {
        field: 'unidade_sigla',
        columnKey: 'unidade.sigla',
        sortable: true,
        header: 'Unidade',
        filter: true,
        columnSortField: 'unidade.sigla',
        relacionamento: ['unidade'],
        fieldJoin: 'sigla',
        visible: true,
      },
    },
  ],
  columns: [],
  currentRecord: {
    oid: '',
    cartao: '',
    codigo: '',
    formaPagamento: '',
    taxas: [],
    unidade: {},
  },
  taxa: {
    parcelaInicial: 0,
    parcelaFinal: 0,
    taxa: 0.0,
    diasCredito: 0,
  },
  messages: null,
  selectedFilters: [],
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDBandeiraReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('bandeira')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    case types.ADD_TAXA:
      return addTaxa(state, action)
    case types.SET_TAXA:
      return setTaxa(state, action)
    case types.ON_CLICK_REMOVE_TAXA:
      return onClickRemoveTaxa(state, action)
    default:
      return state
  }
}

function reset(state, action) {
  return { ...state, currentRecord: initialState.currentRecord, records: [], selectedFilters: [] }
}

function addTaxa(state, action) {
  const taxas = state.currentRecord.taxas || []
  action.payload.hash = new Date().getTime()
  taxas.push(action.payload)
  state.currentRecord.taxas = _.orderBy(taxas, 'parcelaInicial')
  return Object.assign({}, state, {
    taxa: {
      parcelaInicial: 0,
      parcelaFinal: 0,
      taxa: 0.0,
      diasCredito: 0,
    },
  })
}

function setTaxa(state, action) {
  const taxa = state.taxa || {}
  taxa[action.prop] = action.value
  return Object.assign({}, state, { taxa })
}

function onClickRemoveTaxa(state, action) {
  const field = action.payload.oid ? 'oid' : 'hash'
  const taxas = state.currentRecord.taxas || []
  state.currentRecord.taxas = taxas.filter((i) => i[field] !== action.payload[field])
  return Object.assign({}, state)
}
